$(document).ready(function () {  

//Hover Mega Menu Open

let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
    items.forEach(item => {
      item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.querySelector("summary").setAttribute("aria-expanded", true);
        document.body.classList.add("mega_menu_open");
        item.querySelector("ul").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
          document.body.classList.remove("mega_menu_open");
          item.querySelector("summary").setAttribute("aria-expanded", false);
        });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        document.body.classList.remove("mega_menu_open");
        item.querySelector("summary").setAttribute("aria-expanded", false);
      });
    });
  });

// Chat Icon click event
$(document).on('click','.main_chat_button .chat-message-icon', function(e){
  e.preventDefault();
    $(this).parents('.main_chat_button').addClass('active_message_icon');
});

$(document).on('click','.main_chat_button .chat-close-icon', function(e){
  e.preventDefault();
    $(this).parents('.main_chat_button').removeClass('active_message_icon');
});
  
// categories thumbnail 
  var swiper = new Swiper(".thumbnail_list", {
    slidesPerView: 1,
    spaceBetween: 48,
    scrollbar: {
      draggable: true,
      el: ".swiper-scrollbar"
    },
    breakpoints: {
      500: {
        slidesPerView: 2,
      },
      700: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
      1600: {
        slidesPerView: 5,
      },
    },
  });
  
// Feature Collection thumbnail
var swiper = new Swiper(".feature_collection", {
    slidesPerView: 1,
    spaceBetween: 24,
    scrollbar: {
      draggable: true,
      el: ".feature_scrollbar.swiper-scrollbar"
    },
    breakpoints: {
      650: {
        slidesPerView: 2,
      },
      1040: {
        spaceBetween: 48,
        slidesPerView: 3,
      },
    },
  });


  var swiper = new Swiper(".travel-spray-product-carousel", {
    slidesPerView: 1,
    spaceBetween: 24,
    scrollbar: {
      draggable: true,
      el: ".travel-spray_scrollbar.swiper-scrollbar"
    },
    breakpoints: {
      650: {
        slidesPerView: 2,
      },
      1040: {
        spaceBetween: 48,
        slidesPerView: 3,
      },
    },
  });

  var swiper = new Swiper(".travel-spray-product-carousel-popup", {
    slidesPerView: 1,
    spaceBetween: 24,
    scrollbar: {
      draggable: true,
      el: ".travel-spray-product-carousel-popup .travel-spray_scrollbar.swiper-scrollbar"
    },
    breakpoints: {
      650: {
        slidesPerView: 2,
      },
      1040: {
        spaceBetween: 24,
        slidesPerView: 3,
      },
    },
  });
window.addEventListener('resize', function(event){
  $('.mobile_media_gallery .main_media_gallery').slick('refresh');
  $('.mobile_media_gallery .thumbnail_media_gallery').slick('refresh');
});
  // product mobile slider
  $('.mobile_media_gallery .main_media_gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    fade: true,
    asNavFor: '.mobile_media_gallery .thumbnail_media_gallery'
  });
  $('.mobile_media_gallery .thumbnail_media_gallery').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.mobile_media_gallery .main_media_gallery',
    dots: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      }
    ]
  });
  
  $('.banner-slider .image_video').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 8000,
    asNavFor: '.banner-slider .banner_details'
  });
  $('.banner-slider .banner_details').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,    
    fade: true,
    autoplay: true,
    autoplaySpeed: 8000,
    cssEase: 'linear',
    asNavFor: '.banner-slider .image_video',    
    focusOnSelect: true
  });
  
  $(".product-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
    ],
  });
  $(".video-slider-sec .video-row").slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
     responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".reviews-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false
  });
  
  // $(document).on('click','.accordion details',function(e) {
  //   e.preventDefault();
  //   if($(this).attr('open')){
  //    $(this).attr('open', false); 
  //   }else{
  //     $('.accordion details').attr('open', false);
  //     $(this).attr('open', true); 
  //   }
  // });
  
});
// Search box event change

$('.search__input').keyup(function () {
  if($(this).val().length === 0){
    $('.search__button').hide();
    $('.search_text_val').show();
  }else{
    $('.search__button').show();
    $('.search_text_val').hide();
  }
});

// sub_mega_menu open
$(".main_mega_menu button.mega_menu_sub").hover(function () {
//$(document).on('hover','.main_mega_menu button.mega_menu_sub',function(){
  var mega_menu_handle = $(this).data('handle');
  console.log(mega_menu_handle);
  $('.sub_mega_menu').removeClass('active');
  $('.single_menu li').removeClass('active');
  $('#'+mega_menu_handle).addClass('active');
  $(this).parent().addClass('active');
});

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
$(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
// $("ul.tabs li").click(function() {
//   var parent = $(this).parents('.tab-container');

//   $(parent).find(".tab_content").hide();
//   var activeTab = $(this).attr("rel");
//   $(parent).find("#"+activeTab).fadeIn();

//   $(parent).find("ul.tabs li").removeClass("active");
//   $(this).addClass("active");

//   $(parent).find(".tab_drawer_heading").removeClass("d_active");
//   $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

// });
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");



// popup

$(document).ready(function() {

  $('.sm_open').on('click', function(){
      var modal = $(this).attr('data-modal');
      var modaloverlaycolor = $(this).attr('data-overlay');
      var modaleffect = $(this).attr('data-effect');
      var modalheader = $(this).attr('data-header');
      var modalheadertype = $(this).attr('data-header-type');
      var modalcontent = $(this).attr('data-content');
      var modaliconside = $(this).attr('data-icons');
      var modalwrappercolor = $(this).attr('data-wrapper-color');
  
      $('#' + modal).addClass(modaloverlaycolor);
      $('#' + modal + ' .sm_content').addClass(modaleffect);
      $('#' + modal + ' .sm_content .sm_header').html(modalheader);
      $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
      $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
      $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
      $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
      $('#' + modal).fadeIn().css("display", "flex");
      setTimeout(function(){
          $('#'+modal + ' .sm_content').addClass('show');
      }, 400);        
  });
  
  $('.sm_close').on('click', function(){
      var $modal = $(this).parents('.slim_modal');
      closeModal($modal);  
  });
  
  $('.slim_modal').on('click', function(e) {
    if (e.target !== this)
      return;
      var $modal = $(this);
      closeModal($modal);
  });
  
  function closeModal($modal) {
      $modal.find('.sm_content').removeClass('show');
      setTimeout(function(){
          $modal.removeClass('red green tan none');
          $modal.find('.sm_content').removeClass('red green tan');
          $modal.find('.sm_icon_menu').removeClass('is_right is_left');
          $modal.find('.sm_header').removeClass('detached');
          $modal.fadeOut();
      }, 400);
  }

  $(document).on('click', '.announcement-bar .close_button', function() {
    createCookie("announcement-bar-popup", "closed", 1);
    $('.announcement-bar-section').hide();
  });
  if (readCookie('announcement-bar-popup') == "closed") {
     $('.announcement-bar-section').hide();
  }  
});

function createCookie(name, value, days) {
  var expires;
  
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}
function readCookie(name) {
  var nameEQ = encodeURIComponent(name) + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ')
        c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0)
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}
$(document).ready(function(){ 
    $('.tab').click(function(){  
        // Remove the 'tab-active' class from all tab contents
        $(".tab-contains").removeClass('tab-active');

        // Add the 'tab-active' class to the tab content that matches the clicked tab's data-id
        $(".tab-contains[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");

        // Remove the 'active' class from all tabs
        $(".tab").removeClass('active');

        // Add the 'active' class to the clicked tab
        $(this).addClass('active');
    });  
});

$(window).scroll(function() { 
    var scroll = $(window).scrollTop();
    var windowHeight = $('#shopify-section-text-image-animation').height();
    if(windowHeight != undefined){
      var InnerHight = $('#shopify-section-text-image-animation').offset().top + 150;
      var overviewScrollTop = InnerHight - $(window).scrollTop();
  
      if (windowHeight > overviewScrollTop) {
        $(".text-image-animation .flex-box.aos-init").addClass("animation-start");
      }else{
        $(".text-image-animation .flex-box.aos-init").removeClass("animation-start");
      }
    }
});

// UTM parameters
document.addEventListener("DOMContentLoaded", function () {
  // Function to get UTM parameters
  function getUTMParameters() {
    const params = new URLSearchParams(window.location.search);
    const utmParams = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((key) => {
      if (params.has(key)) {
        utmParams[key] = params.get(key);
      }
    });
    return utmParams;
  }

  // Function to append UTM parameters to a specific link
  function appendUTMToLink(link, utmParams) {
    if (!link || Object.keys(utmParams).length === 0) return;
    const url = new URL(link.href, window.location.origin);
    for (const [key, value] of Object.entries(utmParams)) {
      url.searchParams.set(key, value);
    }
    link.href = url.toString();
  }

  // Persist UTM parameters in the current URL
  function persistUTMInURL(utmParams) {
    if (Object.keys(utmParams).length > 0) {
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of Object.entries(utmParams)) {
        currentUrl.searchParams.set(key, value);
      }
      window.history.replaceState({}, document.title, currentUrl.toString());
    }
  }

  // Update all links with UTM parameters
  function updateLinks(utmParams) {
    const links = document.querySelectorAll('a[href^="/"], a[href^="' + window.location.origin + '"]');
    links.forEach((link) => appendUTMToLink(link, utmParams));
  }

  // Update the "Go to bag" link in the cart drawer
  function updateCartDrawerLink(utmParams) {
    const cartDrawerLink = document.querySelector('a[href="/cart"]'); // Adjust selector if needed
    appendUTMToLink(cartDrawerLink, utmParams);
  }

  // Update the "Back to shopping" button when the cart is empty
  function updateBackToShoppingButton(utmParams) {
    const backToShoppingButton = document.querySelector('a.button_custom[href="/collections/all-fragrances"]'); // Exact selector for "Back to shopping" button
    appendUTMToLink(backToShoppingButton, utmParams);
  }

  // Observe cart updates and dynamically update the "Go to bag" and "Back to shopping" links
  function observeCartUpdates(utmParams) {
    const cartDrawer = document.querySelector('#CartDrawer'); // Adjust selector if needed
    if (!cartDrawer) return;

    // MutationObserver to detect when the cart drawer is updated
    const observer = new MutationObserver(() => {
      updateCartDrawerLink(utmParams);
      updateBackToShoppingButton(utmParams);
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }

  // Initialize
  const utmParams = getUTMParameters();
  persistUTMInURL(utmParams); // Persist UTM in the current URL
  updateLinks(utmParams); // Update all internal links with UTM parameters
  updateCartDrawerLink(utmParams); // Update the "Go to bag" link
  updateBackToShoppingButton(utmParams); // Update the "Back to shopping" button
  observeCartUpdates(utmParams); // Observe cart drawer updates
});

/* Klarna messaging */
/* Home */
document.addEventListener('DOMContentLoaded', () => {
  const TARGET_SELECTORS = [
    'div.loaded.default.homepage-promotion-wide',
    'div.loaded.default.homepage-promotion-box'
  ];

  function applyStylesInRoot(root) {
    let appliedCount = 0;

    TARGET_SELECTORS.forEach(sel => {
      const nodes = root.querySelectorAll(sel);
      nodes.forEach(el => {
        el.style.setProperty('display', 'block', 'important');
        el.style.setProperty('margin', 'auto', 'important');
        appliedCount += 1;
        console.log(`Styles applied to ${sel}`);
      });
    });

    return appliedCount;
  }

  function observeShadowRoot(shadowRoot) {
    // Try immediately
    let count = applyStylesInRoot(shadowRoot);
    if (count > 0) return;

    // Observe future mutations inside the shadow root
    const shadowObserver = new MutationObserver(() => {
      const appliedNow = applyStylesInRoot(shadowRoot);
      if (appliedNow > 0) {
        shadowObserver.disconnect();
      }
    });

    shadowObserver.observe(shadowRoot, { childList: true, subtree: true });
  }

  function handlePlacement(el) {
    if (!el) return;
    // If the element already has an open shadow root, use it
    if (el.shadowRoot) {
      observeShadowRoot(el.shadowRoot);
    } else {
      // Watch for shadow root or children being attached later
      const ro = new MutationObserver(() => {
        if (el.shadowRoot) {
          ro.disconnect();
          observeShadowRoot(el.shadowRoot);
        }
      });
      ro.observe(el, { childList: true, subtree: true });
    }
  }

  // Process any existing placements
  document.querySelectorAll('klarna-placement').forEach(handlePlacement);

  // Also watch for placements added later
  const docObserver = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.matches && node.matches('klarna-placement')) {
            handlePlacement(node);
          }
          node.querySelectorAll?.('klarna-placement').forEach(handlePlacement);
        }
      });
    });
  });

  docObserver.observe(document.body, { childList: true, subtree: true });
});


// desktop PDP handle video play n pause 
document.addEventListener('DOMContentLoaded', function () {
  const playBtn = document.querySelector('.video-play-button');
  const videoContainer = document.querySelector('#videoPopupplay');
  const videoPlayBox = document.querySelector('.video_play_box');
  const mainVideo = videoContainer ? videoContainer.querySelector('video') : null;

  if (!playBtn || !videoContainer) {
    console.warn('Play button or video container not found');
    return;
  }

  playBtn.addEventListener('click', function () {
    videoContainer.classList.remove('hidden');
    videoPlayBox.classList.add('hidden');
    if (mainVideo) mainVideo.play();
  });

  if (mainVideo) {
    mainVideo.addEventListener('pause', function () {
      console.log('Video paused');
      // Do any action you want when paused
      videoContainer.classList.add('hidden');
      videoPlayBox.classList.remove('hidden');
    });
  }
});

// mobile PDP handle video play n pause 
document.addEventListener('DOMContentLoaded', function () {
  const mplayBtn = document.querySelector('.mvideo-play-button');
  const mvideoContainer = document.querySelector('#mvideoPopupplay');
  const mvideoPlayBox = document.querySelector('.mvideo_play_box');
  const mobmainVideo = mvideoContainer ? mvideoContainer.querySelector('video') : null;

  if (!mplayBtn || !mvideoContainer) {
    console.warn('Play button or video container not found');
    return;
  }

  mplayBtn.addEventListener('click', function () {
    mvideoContainer.classList.remove('hidden');
    mvideoPlayBox.classList.add('hidden');
    if (mobmainVideo) mobmainVideo.play();
  });

  if (mobmainVideo) {
    mobmainVideo.addEventListener('pause', function () {
      console.log('Video paused');
      // Do any action you want when paused
      mvideoContainer.classList.add('hidden');
      mvideoPlayBox.classList.remove('hidden');
    });
  }
});

